import React from 'react';
import '../assets/css/Footer.css';

export default function Footer() {
    return (
        <div className="section" id="contact">
            <h2>Let's get in touch</h2>
            <div className="footerLinks">
                <a className="footerLink" href="https://www.linkedin.com/in/zijin-huang" target="_blank" rel="noreferrer">LinkedIn</a>
                <a className="footerLink" href="mailto:jimmy1999.huang@gmail.com">Email</a>
            </div>
        </div>
    )
}
